// Add your custom JS here.

(function ($) {
    var ticking = false;
    let lastKnownScrollPosition = window.scrollY;

    $(window).on("elementor/frontend/init", () => {
        // Script for Posts Widget with Sakata skin
        // @TODO : move it to slider-cards.js or in its own JS file
        elementorFrontend.hooks.addAction("frontend/element_ready/posts.sakata", ($element) => {
            if ($($element).find(".elementor-grid-scroll").length) {
                // Update Posts opacities on page load.
                updateSakataPostsOpacities(lastKnownScrollPosition);

                // Setup Scroll animation on scroll
                let scrollAnimation = false;
                $($element)
                    .find(".elementor-posts--skin-sakata")
                    .each(function () {
                        const parentRelative = $(this).closest(".e-parent");
                        const stickyEl = parentRelative.find(".elementor-sticky");
                        if (stickyEl.length) {
                            scrollAnimation = true;
                            $(this).find(".elementor-post").addClass("not-active");
                        }
                    });

                if (scrollAnimation) {
                    document.addEventListener("scroll", function (e) {
                        lastKnownScrollPosition = window.scrollY;

                        if (!ticking) {
                            window.requestAnimationFrame(function () {
                                updateSakataPostsOpacities(lastKnownScrollPosition);
                                ticking = false;
                            });
                            ticking = true;
                        }
                    });
                }
            } else if ($($element).find(".swiper").length) {
                // Setup Swiper slider
                const slider = $($element).find(".swiper");

                const settings = {
                    autoplay: slider.data("autoplay"),
                    autoplaySpeed: slider.data("autoplay-speed"),
                    pauseHover: slider.data("pause-hover"),
                    pauseInteraction: slider.data("pause-interaction"),
                    loop: slider.data("loop"),
                    transition: slider.data("transition"),
                    transitionSpeed: slider.data("transition-speed"),
                    spaceBetweenDesktop: slider.data("space-between-desktop"),
                    spaceBetweenTablet: slider.data("space-between-tablet"),
                    spaceBetweenMobile: slider.data("space-between-mobile"),
                    slidesPerViewDesktop: slider.data("slides-per-view-desktop"),
                    slidesPerViewTablet: slider.data("slides-per-view-tablet"),
                    slidesPerViewMobile: slider.data("slides-per-view-mobile"),
                    centeredSlidesDesktop: slider.data("centered-slide-desktop"),
                    centeredSlidesTablet: slider.data("centered-slide-tablet"),
                    centeredSlidesMobile: slider.data("centered-slide-mobile"),
                    direction: slider.attr("dir"),
                };
                const sliderEls = {
                    pagination: slider.find(".swiper-pagination"),
                    prev: slider.find(".swiper-button-prev"),
                    next: slider.find(".swiper-button-next"),
                };

                const asyncSwiper = elementorFrontend.utils.swiper;

                const carousselSwiperConfig = {
                    slidesPerView: settings.slidesPerViewMobile || 1,
                    spaceBetween: settings.spaceBetweenMobile || 15,
                    centeredSlides: settings.centeredSlidesMobile || true,
                    // scrollbar: {
                    //     el: sliderEls.scrollbar ? sliderEls.scrollbar[0] : null,
                    //     draggable: true,
                    // },
                    // Pagination
                    pagination: {
                        el: sliderEls.pagination ? sliderEls.pagination[0] : null,
                    },
                    // Boutons de navigation
                    navigation: {
                        prevEl: sliderEls.prev ? sliderEls.prev[0] : null,
                        nextEl: sliderEls.next ? sliderEls.next[0] : null,
                    },
                    autoplay:
                        settings.autoplay === "yes"
                            ? {
                                  delay: settings.autoplaySpeed || 3000,
                                  disableOnInteraction: settings.pauseInteraction === "yes",
                                  pauseOnMouseEnter: settings.pauseHover === "yes",
                                  reverseDirection: settings.direction === "rtl",
                                  stopOnLastSlide: false,
                              }
                            : false,
                    loop: settings.loop === "yes",
                    loopAdditionalSlides: 1, // Required to avoid having a blank slide when Loop is activated
                    speed: settings.transitionSpeed,
                    effect: settings.transition,
                    fadeEffect: {
                        crossFade: true,
                    },
                    breakpoints: {
                        744: {
                            slidesPerView: settings.slidesPerViewTablet || 2,
                            spaceBetween: settings.spaceBetweenTablet || 15,
                            centeredSlides: settings.centeredSlidesTablet || false,
                        },
                        1025: {
                            slidesPerView: settings.slidesPerViewDesktop || 2,
                            spaceBetween: settings.spaceBetweenDesktop || 15,
                            centeredSlides: settings.centeredSlidesDesktop || false,
                        },
                    },
                };

                new asyncSwiper(slider, carousselSwiperConfig);
            } else if ($($element).find(".elementor-grid-columns").length) {
                // Setup AJAX filtering
                const widgetID = $element[0].getAttribute("data-id");
                const filterItems = $element[0].querySelectorAll(".elementor-posts-filters__item"); // A Filter item
                const postsContainer = $element[0].querySelector(".elementor-grid-columns"); // Posts to Update
                const filtersData = $element[0].querySelector("#elementor-posts-filters-datas");

                const postsPerPage = filtersData.getAttribute("data-posts-per-page");

                const postRequest = (targetUrl, categoryID, page) => {
                    fetch(targetUrl, {
                        method: "POST",
                        action: "ajax_filters",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({
                            cat: categoryID,
                            paged: page,
                            postsPerPage,
                            widgetID,
                        }),
                    })
                        .then((response) => {
                            return response.text();
                        })
                        .then((response) => {
                            if (response) {
                                postsContainer.innerHTML = response;
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                };

                filterItems.forEach((item) => {
                    item.addEventListener("click", (e) => {
                        filterItems.forEach((item) => {
                            item.classList.remove("elementor-posts-filters__item--active");
                        });
                        item.classList.add("elementor-posts-filters__item--active");

                        const categoryID = item.getAttribute("data-catid");

                        if (categoryID == null) {
                            return;
                        }

                        postRequest(ajaxscript.ajax_url, categoryID, "1");
                    });
                });
            }
        });

        // Script for Text Path Widget
        elementorFrontend.hooks.addAction("frontend/element_ready/text-path.default", ($element) => {
            setupTextPathAnimation($element);
        });

        // Script for ElementorPro's Menu Widget
        elementorFrontend.hooks.addAction("frontend/element_ready/mega-menu.default", ($element) => {
            setupMenu($element);
        });

        // Gravity Forms
        // Re-open Elementor PopUp if a Gravity Form is inside a PopUp and has Errors or Confirmation message
        // Because Gravity Forms reload the page on Form Validation, and so the PopUp is closed on reload.
        elementorFrontend.on("components:init", function () {
            const documents = elementorFrontend.documentsManager.documents;
            Object.values(documents).forEach((document) => {
                if (typeof document.getModal === "function") {
                    const modal = $(document.elementHTML);
                    const gform_errors = modal.find(".gform_validation_errors");
                    const gform_confirmation = modal.find(".gform_confirmation_message");
                    if (gform_errors.length > 0 || gform_confirmation.length > 0) {
                        document.showModal();
                    }
                }
            });
        });
    });

    // Handle menu opening
    $(document).on("click", ".e-n-menu-title.e-click", function () {
        const opening = $(this).find(".e-n-menu-dropdown-icon").attr("aria-expanded") === "true";
        const textBtn = $(this).find(".e-n-menu-title-text");
        if (opening) {
            $("body").addClass("noscroll");
            $(".elementor-location-header[data-elementor-type='header']").addClass("menu-opened");
            $("html").css("overflow", "hidden"); // prevent scroll for mobile
            $(this).closest(".elementor-widget-n-menu").addClass("menu-opened");
            const closeText = textBtn.attr("close-text");
            textBtn.text(closeText);
        } else {
            $("body").removeClass("noscroll");
            $(".elementor-location-header[daat-elementor-type='header']").removeClass("menu-opened");
            $("html").css("overflow", ""); // prevent scroll for mobile
            $(this).closest(".elementor-widget-n-menu").removeClass("menu-opened");
            const openText = textBtn.attr("open-text");
            textBtn.text(openText);
        }
    });

    // Handle mobile menu
    $(document).on("click", ".elementor-widget-n-menu__back-btn", function (e) {
        e.stopImmediatePropagation();
        $(this).closest(".elementor-widget-n-menu").removeClass("submenu-opened");
    });
    $(document).on("hide.bs.collapse", ".elementor-link-list__list__wrapper.collapse", function (event) {});
    $(document).on("show.bs.collapse", ".elementor-link-list__list__wrapper.collapse", function (event) {
        const menu = $(this).closest(".elementor-widget-n-menu");
        const collapseID = $(this).attr("id");
        const openingMenu = $(this).closest(".elementor-widget-sakata-link-list");
        const backBtn = menu.find(".elementor-widget-n-menu__back-btn");

        menu.addClass("submenu-opened");
        menu.find(".elementor-widget-sakata-link-list.active-menu").each(function () {
            // Close previous active menu
            const currentActive = $(this);
            if (!currentActive.is(openingMenu)) {
                currentActive.removeClass("active-menu");
                currentActive.find(".elementor-link-list__list__wrapper.collapse").collapse("hide");
            }
        });
        openingMenu.addClass("active-menu");
        backBtn.attr("href", `#${collapseID}`);
        backBtn.attr("aria-controls", `${collapseID}`);
        backBtn.attr("aria-expanded", true);
    });

    const updateSakataPostsOpacities = function (scrollY) {
        $(".elementor-posts--skin-sakata.elementor-grid-scroll").each(function () {
            const parentRelative = $(this).closest(".e-parent");
            const stickyEl = parentRelative.find(".elementor-sticky");
            const stickyParams = stickyEl.data("settings");
            const stickyOffset = stickyParams?.sticky_offset || 0;

            if (!parentRelative.length) return;

            const posts = $(this).find(".elementor-post");

            posts.each(function () {
                const postTop = this.getBoundingClientRect().top;
                if (postTop >= stickyOffset / 2) {
                    posts.removeClass("active");
                    posts.removeClass("near-active");

                    const post = $(this);
                    post.addClass("active");
                    post.addClass("activing");
                    post.next().addClass("active");
                    post.next().addClass("activing");
                    post.next().next().addClass("near-active");
                    post.prev().addClass("near-active");
                    setTimeout(function () {
                        post.removeClass("activing");
                        post.next().removeClass("activing");
                    }, 250);
                    return false;
                }
            });
        });
    };

    const setupTextPathAnimation = function (element, tries = 10, delayBetweenTries = 100) {
        const ID = element[0].getAttribute("data-id");
        const identifier = ".elementor-element-" + ID + " svg";
        const textContainer = document.querySelector(".elementor-element-" + ID + " svg");

        if (!textContainer && tries > 0) {
            setTimeout(function () {
                setupTextPathAnimation(element, tries - 1);
            }, delayBetweenTries);
            return;
        }

        const textPath = document.querySelector(".elementor-element-" + ID + " svg textPath");
        const path = document.querySelector(textPath.getAttribute("href"));
        const pathLength = path.getTotalLength();

        function updateTextPathOffset(offset) {
            const margin = window.innerWidth < 744 ? -1500 : -500;
            const direction = 1; // Right to left = 1 // Left to right = -1
            textPath.setAttribute("startOffset", (offset + margin) * direction);
        }

        updateTextPathOffset(pathLength);

        function onScroll() {
            requestAnimationFrame(function () {
                const rect = textContainer.getBoundingClientRect();
                const scrollPercent = rect.y / window.innerHeight;
                const speed = 1.5;
                updateTextPathOffset(scrollPercent * speed * pathLength);
            });
        }
        window.addEventListener("scroll", onScroll);
    };

    const setupMenu = function (menuElement) {
        const ID = menuElement[0].getAttribute("data-id");
        const menuIdentifier = ".elementor-element-" + ID;
        const menuBtns = $(`${menuIdentifier} .e-n-menu-title.e-click`);

        menuBtns.each(function () {
            const textBtn = $(this).find(".e-n-menu-title-text");
            if (!textBtn.attr("open-text")) {
                const openText = textBtn.text().trim();
                textBtn.attr("open-text", openText);
            }
        });

        onClickOutside(`${menuIdentifier}`, () => {
            if ($(`${menuIdentifier}`).hasClass("menu-opened")) {
                $("body").removeClass("noscroll");
                $(`${menuIdentifier}`).removeClass("menu-opened");
                const textBtn = $(`${menuIdentifier} .e-n-menu-title.e-click .e-n-menu-title-text`);
                const openText = textBtn.first().attr("open-text");
                textBtn.text(openText);
            }
        });
    };
})(jQuery);

document.addEventListener("DOMContentLoaded", (event) => {
    checkHeader();
    setupSearch();
});
const headerSelector = ".elementor-location-header[data-elementor-type='header']";
const checkHeader = function (e) {
    const header = document.querySelector(headerSelector);
    if (window.scrollY > 0) {
        header.classList.add("header-scrolled");
    } else {
        header.classList.remove("header-scrolled");
    }
};
window.addEventListener("scroll", checkHeader);

const onClickOutside = (element, callback) => {
    const EL = typeof element === "string" ? document.querySelector(element) : element;
    document.addEventListener("click", (e) => {
        if (!EL.contains(e.target)) callback();
    });
};

const setupSearch = function () {
    setupSearchWidth();

    document.addEventListener("click", (e) => {
        if (e.target.classList.contains("search-submit") || e.target.closest(".search-submit")) {
            const wrapper = e.target.closest(".searchwp-form-wrapper");
            if (wrapper && !wrapper.classList.contains("opened")) {
                e.preventDefault();
                wrapper.classList.toggle("opened");
            }
        }
    });
    onClickOutside(".elementor-location-header[data-elementor-type='header'] .searchwp-form", function () {
        const wrapper = document.querySelector(
            ".elementor-location-header[data-elementor-type='header'] .searchwp-form .searchwp-form-wrapper"
        );
        if (wrapper) wrapper.classList.remove("opened");
    });
};

const setupSearchWidth = function () {
    const searchWrapper = document.querySelector(
        ".elementor-location-header[data-elementor-type='header'] .searchwp-form .searchwp-form-wrapper"
    );
    const searchBtn = document.querySelector(
        ".elementor-location-header[data-elementor-type='header'] .searchwp-form .search-submit"
    );

    if (searchWrapper && searchBtn) {
        const offsetWidth = searchBtn.offsetWidth;
        searchWrapper.style.setProperty("--search-w", offsetWidth + "px");
    }
};

const setupBackgroundImageLazyLoading = function (target = null) {
    if ("IntersectionObserver" in window) {
        document.addEventListener("DOMContentLoaded", function () {
            function handleIntersection(entries, observer) {
                entries.map((entry) => {
                    if (entry.isIntersecting) {
                        // Item has crossed our observation
                        // threshold - load src from data-src
                        entry.target.classList.remove("bg-lazyload");
                        entry.target.classList.add("bg-lazyloaded");

                        // Job done for this item - no need to watch it!
                        observer.unobserve(entry.target);
                    }
                });
            }

            const lazyloads = target || document.querySelectorAll(".bg-lazyload");
            const lazyObserver = new IntersectionObserver(handleIntersection, { rootMargin: "300px", threshold: 0.01 });
            lazyloads.forEach((toLazyload) => lazyObserver.observe(toLazyload));
        });
    } else {
        // No interaction support? Load all background images automatically
        const lazyloads = document.querySelectorAll(".bg-lazyload");
        lazyloads.forEach((toLazyload) => {
            toLazyload.classList.remove("bg-lazyload");
            toLazyload.classList.add("bg-lazyloaded");
        });
    }
};
setupBackgroundImageLazyLoading();
